var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "up",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 9.0618038 4.9977479",
    style: {
      enableBackground: "new 0 0 9.0618038 4.9977479"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "up_1_",
    d: "M4.5330653,4.9971452c0.1291351,0.0055304,0.2599044-0.0390019,0.3571134-0.1362109l4.034811-4.0348115 c0.1821251-0.1821241,0.1846161-0.4932299-0.0057316-0.6835775C8.734478-0.0422354,8.422863-0.0503683,8.2356806,0.1368136 L4.5308294,3.8416653L0.8259781,0.1368136C0.643854-0.0453105,0.3327482-0.047802,0.1424005,0.1425452 c-0.1847811,0.1847806-0.192914,0.4963956-0.0057316,0.6835775l4.034811,4.0348115 C4.268127,4.957581,4.4010959,5.0036426,4.5330653,4.9971452z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnArrowDown);
export default __webpack_public_path__ + "static/media/BtnArrowDown.5caa2363.svg";
export { ForwardRef as ReactComponent };